import type { ConditionBuildable, ConditionBuilder, EffectiveConditionBuilderSpec } from "../../types/index.ts";

type Options = Pick<ConditionBuildable, "retired">;

// shortcut less verbose but creates function call at runtime just to get types at build time?!
export const createConditionBuildable = <TBuilder extends ConditionBuilder<any>>(
  builder: TBuilder,
  name: string,
  spec: TBuilder extends ConditionBuilder<infer TContext>
    ? EffectiveConditionBuilderSpec<TContext["spec"]>
    : EffectiveConditionBuilderSpec,
  children: ConditionBuildable<TBuilder>["children"] = {},
  options: Options = {},
): Omit<ConditionBuildable<TBuilder>, "nodeId"> => ({
  name,
  builder,
  spec,
  children,
  ...options,
});
